import VisaLogo from '@/assets/logos/visa.svg';
import AmexLogo from '@/assets/logos/amex.svg';
import CartesBancairesLogo from '@/assets/logos/cartes-bancaires.svg';
import MastercardLogo from '@/assets/logos/mastercard.svg';
import DiscoverLogo from '@/assets/logos/discover.svg';
import DinersClubLogo from '@/assets/logos/diners-club.svg';
import JcbLogo from '@/assets/logos/jcb.svg';
import LinkLogo from '@/assets/logos/link.svg';
import EftposAuLogo from '@/assets/logos/eftpos-au.svg';
import UnionpayLogo from '@/assets/logos/unionpay.svg';

import Enum from '@/modules/core/app/helpers/Enum';

export class StripePaymentCardBrand extends Enum {
  key!: string;
  logo!: string | null;

  static VISA = {
    key: 'visa',
    logo: VisaLogo
  };

  static AMEX = {
    key: 'amex',
    logo: AmexLogo
  };

  static CARTES_BANCAIRES = {
    key: 'cartes_bancaires',
    logo: CartesBancairesLogo
  };

  static MASTERCARD = {
    key: 'mastercard',
    logo: MastercardLogo
  };

  static DISCOVER = {
    key: 'discover',
    logo: DiscoverLogo
  };

  static DINERS_CLUB = {
    key: 'diners_club',
    logo: DinersClubLogo
  };

  static JCB = {
    key: 'jcb',
    logo: JcbLogo
  };

  static LINK = {
    key: 'link',
    logo: LinkLogo
  };

  static EFTPOS_AU = {
    key: 'eftpos_au',
    logo: EftposAuLogo
  };

  static UNIONPAY = {
    key: 'unionpay',
    logo: UnionpayLogo
  };

  static UNKNOWN = {
    key: 'unknown',
    logo: null
  };
}
